import script from "./LockForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LockForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__